import { useWallet } from '@solana/wallet-adapter-vue'
import { useQuasar } from 'quasar'
import { shortenAddress } from '~/utils'

export const WALLET_CONNECT_EVENT = Symbol('WALLET_CONNECT_EVENT')
export const WALLET_DISCONNECT_EVENT = Symbol('WALLET_DISCONNECT_EVENT')
export const ACCOUNT_CHANGE_EVENT = Symbol('ACCOUNT_CHANGE_EVENT')

const noticeTimeout = 5000

export function initWallet() {
  const { connection } = useConnectionStore()
  const { emit } = useEmitter()
  const { notify } = useQuasar()
  const { wallet } = useWallet()
  const subscriptionId = ref<number | undefined>()
  const subscriptionLogsId = ref<number | undefined>()

  watchDebounced(
    wallet,
    (w) => {
      if (!w) {
        return
      }

      const onConnect = () => {
        const publicKey = w.adapter.publicKey!
        connection.onAccountChange(publicKey, (acc) => {
          emit(ACCOUNT_CHANGE_EVENT, acc)
        })
        connection.onLogs(publicKey, (logs) => {
          console.log(logs)
        })
        notify({
          message: 'Wallet update',
          caption: `Connected to wallet ${shortenAddress(publicKey.toBase58(), 7)}`,
          timeout: noticeTimeout,
        })
        emit(WALLET_CONNECT_EVENT, w)
      }

      const onDisconnect = () => {
        notify({
          message: 'Wallet update',
          caption: 'Disconnected from wallet',
          timeout: noticeTimeout,
        })
        if (subscriptionId.value !== undefined) {
          connection.removeAccountChangeListener(subscriptionId.value)
          subscriptionId.value = undefined
        }
        if (subscriptionLogsId.value !== undefined) {
          connection.removeOnLogsListener(subscriptionLogsId.value)
          subscriptionLogsId.value = undefined
        }
        emit(WALLET_DISCONNECT_EVENT, w)
      }

      const onError = (e: any) => {
        if (!e?.message) {
          return
        }
        notify({
          type: 'negative',
          message: 'Wallet update',
          caption: e.message,
          timeout: noticeTimeout,
        })
      }

      w.adapter.once('connect', onConnect)
      w.adapter.once('disconnect', onDisconnect)

      w.adapter.removeAllListeners('error')
      w.adapter.on('error', onError)
    },
    { immediate: true, debounce: 500, maxWait: 1000 },
  )
}
